<template>
    <div class="">
        <div class="row">
            <div class="col-12">
                <div class="main--content-header">
                    <search-input-component
                        placeholder="Search"
                        :emit_instead="true"
                        @submit="search"
                    ></search-input-component>
                </div>
            </div>
        </div>

        <div id="clients-accordion" class="">
            <collapsable v-for="(client, index) in clients_filtered" :key="client.id" :title="client.name" accordion="#clients-accordion" :show="index === 0">
                <template slot="content">
                    <list-item v-for="site in client.sites" :key="site.id" @click="showSite(client, site)">
                        <template slot="title">
                            <div>
                                <h5>{{site.name}}</h5>
                                <h6>{{site.address}}</h6>
                            </div>
                        </template>
                    </list-item>
                </template>
            </collapsable>
        </div>

        <div class="mt-5 text-center" v-if="!clients.length">
            <h4>No clients found</h4>
        </div>
    </div>
</template>

<script>
	import SearchInputComponent from "../general_components/SearchInputComponent";
    import Collapsable from "../ListComponent/Collapsable";
    import ListItem from "../ListComponent/ListItem";
    export default {
		name: "ClientsPage",
        components: {ListItem, Collapsable, SearchInputComponent},
        props: [
            'clients',
			'show_site_url'
        ],

        data(){
		    return {
		        clients_filtered: []
            }
        },

        beforeMount() {
		    this.clients_filtered = this.clients;
        },

        methods: {
		    search(val){
		        let clients = [];
                val = val.toLowerCase();

                this.clients.forEach(function (client){
                    if (client.name.toLowerCase().indexOf(val) !== -1){
                        clients.push(client);
                    }
                    else {
                        let client_found = null;
                        for (let i = 0; i < client.sites.length; i++){
                            if (client.sites[i].name.toLowerCase().indexOf(val) !== -1){
                                if (!client_found) {
                                    client_found = Object.assign({}, client);
                                    client_found.sites = [];
                                }
                                client_found.sites.push(client.sites[i]);
                            }
                        }
                        if (client_found) clients.push(client_found);
                    }
                });

                this.clients_filtered = clients;
            },
			showSite(client, site){
		    	window.location.href = this.show_site_url.replace('?c', client.id).replace('?s', site.id);
			}
        },
	}
</script>
